export default "__VITE_ASSET__C7J40mz1__"